<template>
	<div class="p-component summary-content">
		<div class="p-grid p-jc-between">
      <Message v-if="tenantExists" severity="warn" :closable="false">
        <h3>{{ $t('System-Administration.General.Warning') }}</h3>
        {{ $t('System-Administration.Tenants.TenantWarningMessage') }}
      </Message>
			<Divider align="left">
				<div class="p-d-inline-flex p-ai-center">
					<i class="mdi mdi-badge-account-horizontal-outline p-mr-2"></i>
					<b>{{ $t('System-Administration.Tenants.Tenant') }}</b>
				</div>
			</Divider>
			<div class="p-col-4">
				{{ $t('System-Administration.Tenants.Tenant') }}:
			</div>
			<div class="p-col-8">
				{{ tenant }}
			</div>

			<Divider align="left">
				<div class="p-d-inline-flex p-ai-center">
					<i class="mdi mdi-account-outline p-mr-2"></i>
					<b>{{ $t('System-Administration.General.AdminUser') }}</b>
				</div>
			</Divider>
			<!--<div class="p-col-4">
				{{ $t('System-Administration.Login.Login') }}:
			</div>
			<div class="p-col-8">
				{{ adminUser.login }}
			</div>-->
			<div class="p-col-4">
				{{ $t('System-Administration.Login.Firstname') }}:
			</div>
			<div class="p-col-8">
				{{ adminUser.firstname }}
			</div>
			<div class="p-col-4">
				{{ $t('System-Administration.Login.Lastname') }}:
			</div>
			<div class="p-col-8">
				{{ adminUser.lastname }}
			</div>
			<div class="p-col-4">
				{{ $t('System-Administration.Login.Email') }}:
			</div>
			<div class="p-col-8">
				{{ adminUser.email }}
			</div>
			<div class="p-col-4">
				{{ $t('System-Administration.Login.Password') }}:
			</div>
			<div class="p-col-8">
				******
			</div>

			<Divider align="left">
				<div class="p-d-inline-flex p-ai-center">
					<i class="mdi mdi-application p-mr-2"></i>
					<b>{{ $t('System-Administration.Templates.Templates') }}</b>
				</div>
			</Divider>
			<div class="p-col-4">
				{{ $t('System-Administration.Templates.Templates') }}:
			</div>
			<div class="p-col-8">
				<ul v-for="template of allTemplates" :key="template.key">
					<li v-if="template.checked">{{ template.label }}</li>
					<div v-if="template.checked">
						<ul v-for="child of template.children" :key="child.key">
							<li v-if="child.checked">{{ child.label }}</li>
						</ul>
					</div>
					<div v-if="!template.checked">
						<span v-for="child of template.children" :key="child.key">
						<li v-if="child.checked">{{ child.label }}</li>
					</span>
					</div>
				</ul>
			</div>
		</div>
	</div>
	<div class="p-grid">
		<div class="p-col-6 p-text-left p-mt-2">
			<Button icon="mdi mdi-arrow-left" class="p-button-rounded p-button-outlined" @click="goToPreviousStep"/>
		</div>
		<div class="p-col-6 p-text-right p-mt-2">
			<Button icon="mdi mdi-arrow-right" class="p-button-rounded p-button-outlined" @click="goToNextStep"/>
		</div>
	</div>
</template>

<script lang="ts">
import {defineComponent, ref} from 'vue';
import { useI18n } from 'vue-i18n';
import Divider from 'primevue/divider';
import Message from "primevue/message";

export default defineComponent({
	name: "ProcessItemSummary",
	components: {
		Message,
		Divider,
	},
	props: {
		tenant: {
			type: String,
		},
		tenantExists: {
			type: Boolean,
			default: false,
		},
		adminUser: {
			type: Object,
			required: true,
		},
		allTemplates: {
			type: Array,
		},
	},
	emits: ['goToPreviousOrNextStep'],
	setup(props, {emit}) {
		const {t} = useI18n();

		/** Is loading? */
		const loading = ref<boolean>(false);

		/** Triggered on click to go to the previous step */
		const goToPreviousStep = () => {
			emit('goToPreviousOrNextStep', 1);
		}

		/** Triggered on click to go to the next step */
		const goToNextStep = () => {
			emit('goToPreviousOrNextStep', 3);
		}

		return {
			t,
			loading,
			goToPreviousStep,
			goToNextStep,
		}
	},
})
</script>

<style scoped>

::v-deep(.p-divider-solid.p-divider-horizontal:before) {
	border-top-style: solid !important;
}

.summary-content {
	text-align: initial;
	height: 60vh;
	overflow-y: auto;
	overflow-x: hidden;
}

</style>


